__turbopack_context__.v({
  "SQACTitle": "s5egya_SQACTitle",
  "SQACategory": "s5egya_SQACategory",
});
